<template>
    <router-view />
</template>
<script>
    require('./assets/js/bootstrap.min.js')
    require('./assets/js/on-screen.umd.min')
    require('./assets/js/simplebar.min')
    require('./assets/js/volt')
      require('./assets/css/bootstrap.min.css')
    // require('./assets/css/on-screen.umd.min')
    require('./assets/css/simplebar.min.css')
    require('./assets/css/volt.css')
</script>
<style>
@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.6.3/css/font-awesome.css); 

.hide{
  display:none !important;
}
</style>
